import { Component, inject, OnDestroy, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from 'src/app/controls/dialog/components/dialog.component';
import { CrewService } from '../services/crew.service';
import { CrewDetail } from '../models/crew-detail.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cec-crew-detail-dialog',
  templateUrl: './crew-detail.component.html',
  styleUrls: ['./crew-detail.component.scss'],
  imports: [TranslateModule, DialogComponent],
  standalone: true,
  providers: [CrewService]
})
export class CrewDetailComponent implements OnDestroy {

  protected dialog = viewChild.required<DialogComponent>(DialogComponent);

  private service = inject(CrewService);

  protected crew: CrewDetail | undefined = undefined;

  private sub = new Subscription();

  public show(crewNumber: number): void {
    if (!crewNumber) {
      return;
    }

    this.sub = this.service.getDetail(crewNumber).subscribe((crew: CrewDetail) => {
      this.crew = crew;
      this.dialog().show();
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
